const parseEnumStatus = (status) => {
  switch (status) {
    case 0:
      return 'Menunggu Konfirmasi';
    case 1:
      return 'Disetujui';
    case 2:
      return 'Ditolak';
    default:
      return 'Menunggu Konfirmasi';
  }
}

export { parseEnumStatus };